import { useEffect, useRef } from 'react';

export function useCombinedRefs<T = unknown>(
  ...refs: Array<React.MutableRefObject<T | null> | React.LegacyRef<T> | null>
) {
  const targetRef = useRef<T | null>(null);

  useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else if (ref && typeof ref === 'object') {
        (ref as React.MutableRefObject<T | null>).current = targetRef.current;
      }
    });
  }, [refs]);

  return targetRef;
}
